module.exports = __webpack_public_path__ + "static/img/customercase2.3efe4aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/customercase/customercase2.png
// module id = K8G9
// module chunks = 0